import { AlertCircle, Lightbulb } from 'lucide-react';

const ErrorBlock = ({ message, details, category }) => {
  // Check if it's an "Out of Scope" type error - show as helpful info
  const isOutOfScope = category === 'out_of_scope' || message?.toLowerCase().includes('out of scope');

  if (isOutOfScope) {
    return (
      <div className="border-2 border-amber-400 rounded-lg overflow-hidden bg-amber-50 shadow-md">
        <div className="px-4 py-3 bg-amber-100 border-b-2 border-amber-300">
          <h4 className="font-semibold text-amber-900 flex items-center gap-2 text-base">
            <AlertCircle className="w-5 h-5 text-amber-700" />
            {message || 'Query Not Available'}
          </h4>
        </div>
        <div className="p-5">
          {details && (
            <div className="space-y-3">
              <p className="text-amber-900 text-sm leading-relaxed whitespace-pre-line font-medium">
                {details}
              </p>
            </div>
          )}
        </div>
      </div>
    );
  }

  // Regular error display
  return (
    <div className="border-2 border-red-300 rounded-lg overflow-hidden bg-red-50 shadow-md">
      <div className="px-4 py-3 bg-red-100 border-b-2 border-red-200">
        <h4 className="font-semibold text-red-900 flex items-center gap-2 text-base">
          <Lightbulb className="w-5 h-5 text-red-700" />
          {message || 'Something went wrong'}
        </h4>
      </div>
      <div className="p-5">
        {details && (
          <p className="text-red-800 text-sm font-medium">{details}</p>
        )}
      </div>
    </div>
  );
};

export default ErrorBlock;
